/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPower: {
  name: 'power';
  data: string;
} = {
  name: 'power',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0V1ZM4.65 2.428a.5.5 0 0 0-.516-.856 7.5 7.5 0 1 0 7.731 0 .5.5 0 1 0-.515.856 6.5 6.5 0 1 1-6.699 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
